<template>
  <v-row justify="space-around">
    <v-sheet
      class="d-flex flex-column align-center"
      width="300px"
    >
      <div class="d-flex flex-row">
        <form
          ref="form"
          @submit.prevent="subscribe"
        >
          <v-text-field
            v-model="email"
            :label="opt.label || 'Email Address'"
            type="email"
            :outlined="opt.outlined"
            :filled="opt.filled"
            :light="opt.light"
            :placeholder="opt.placeholder"
            :rounded="opt.rounded"
            :shaped="opt.shaped"
            :solo="opt.solo"
            :solo-inverted="opt['solo-inverted']"
            :flat="opt.flat"
            :elevation="opt.elevation"
            :rules="[rules.required, rules.email]"
            :loading="busy"
            :messages="message"
            :disabled="busy"
          >
            <template v-slot:append-outer>
              <v-btn
                icon
                color="primary"
                type="submit"
                :loading="busy"
                ripple
                small
                :disabled="busy"
                class="ml-3"
              >
                <v-icon
                large
                
                >mdi-send</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-btn
            v-if="showTest"
            icon
            @click="testit"
          >
            <v-icon small>mdi-test-tube</v-icon>
          </v-btn>
        </form>
      </div>
    </v-sheet>
  </v-row>
</template>

<script>
export default {
  props: ['options'],
  data(){
    return {
      showTest: false,
      minHeight: '150px',
      email: null,
      message: null,
      busy: false,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    async subscribe() {
      if (this.email && this.email.length) {
        this.busy = true
        let email = await this.api.post('/mailchimp/subscribe', {
          shopID: this.shop._id,
          emailAddress: this.email
        })
        if (email) {
          this.success(email)
        }
      }
    },
    testit(){
      this.busy = true
      window.setTimeout(()=>{
        this.success({created: true})
      }, 2000)
    },
    success(email) {
      if (email.created || email.updated) {
        this.$store.commit('market/openSnackbar', {
          text: 'You\'re Awesome',
          icon: 'mdi-fire',
          timeout: 4000
        })
      } else if (email.exists) {
        this.message = 'Email already exists...'
      }
      this.busy = false
      this.$refs.form.reset()
    }
  },
  computed: {
    shop(){return this.$store.getters['market/shop']},
    opt(){return this.options || {}}
  }
}
</script>